import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const EntryExitList = Loadable(lazy(() => import("features/entryExit/components/List")));
const EntryExitPage = Loadable(lazy(() => import("features/entryExit/components/Page")));


const routes = {
    path: 'entryexit',
    children: [
        { path: '', element: <EntryExitList /> },
        { path: 'add', element: <EntryExitPage /> },
        { path: 'edit/:entryExitID?', element: <EntryExitPage /> },
    ]
};

export default routes;